var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 33,
    viewBox: "0 0 228 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0L20.2045 11.4012H32.1924L22.494 18.4476L26.1985 29.8488L16.5 22.8024L6.80154 29.8488L10.506 18.4476L0.807568 11.4012H12.7955L16.5 0Z",
    fill: "#EC994B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 0L59.2045 11.4012H71.1924L61.494 18.4476L65.1985 29.8488L55.5 22.8024L45.8015 29.8488L49.506 18.4476L39.8076 11.4012H51.7955L55.5 0Z",
    fill: "#EC994B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 0L98.2045 11.4012H110.192L100.494 18.4476L104.198 29.8488L94.5 22.8024L84.8015 29.8488L88.506 18.4476L78.8076 11.4012H90.7955L94.5 0Z",
    fill: "#EC994B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 0L137.204 11.4012H149.192L139.494 18.4476L143.198 29.8488L133.5 22.8024L123.802 29.8488L127.506 18.4476L117.808 11.4012H129.796L133.5 0Z",
    fill: "#EC994B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.5 0L176.204 11.4012H188.192L178.494 18.4476L182.198 29.8488L172.5 22.8024L162.802 29.8488L166.506 18.4476L156.808 11.4012H168.796L172.5 0Z",
    fill: "#EC994B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.5 0L215.204 11.4012H227.192L217.494 18.4476L221.198 29.8488L211.5 22.8024L201.802 29.8488L205.506 18.4476L195.808 11.4012H207.796L211.5 0Z",
    fill: "#EC994B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.f6ce48cf1e733131f51b982423efb8b3.svg";
export { ForwardRef as ReactComponent };